var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineVert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 24,
    viewBox: "0 0 2 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.719319,
    y1: 0.00976559,
    x2: 0.71932,
    y2: 23.5862,
    stroke: "#A5AAAF",
    strokeWidth: 1.42887
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineVert);
export default __webpack_public_path__ + "static/media/lineVert.6b3786949e29ee4a2c67825621c10e01.svg";
export { ForwardRef as ReactComponent };